import type { Requests } from "../common/request.common";
import type { DevToolsResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { buildSelectParam, get, post, postEmpty } from "./common";

export const devtools = {
    transactions() {
        return get<DevToolsResponseTypes.Transactions>(`/devtools/transactions`);
    },
    obtainMaintenance() {
        return get<DevToolsResponseTypes.ObtainMaintenance>(`/devtools/maintenance/obtain`);
    },
    toggleMaintenance(data: typeof Requests.DevTools.ToggleMaintenance.Input) {
        return post<typeof data>(`/devtools/maintenance/toggle`, data);
    },
    clearDebugLogs() {
        return postEmpty(`/devtools/clear-debug-logs`);
    },
    clearErrorLogs() {
        return postEmpty(`/devtools/clear-error-logs`);
    },
    syncIndex() {
        return postEmpty(`/devtools/sync-index`);
    },
    fetchMigrations() {
        return get<DevToolsResponseTypes.FetchMigrations>(`/devtools/migrations/fetch`);
    },
    applyMigration(id: string) {
        return postEmpty(`/devtools/migrations/apply/${id}`);
    },
    resetMigration(id: string) {
        return postEmpty(`/devtools/migrations/reset/${id}`);
    },
    runDaemon(data: typeof Requests.DebugTools.StandaloneDaemon.Input) {
        return post<typeof data>(`/devtools/daemons`, data);
    },
    formHooks: {
        selectDaemons: (async (param?: SelectParam) => {
            const req = get<DevToolsResponseTypes.SelectDaemons>(
                `/devtools/daemons` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
    },
};
